<template>
  <div class="wrap">
    <div>
      <GmapMap
        ref="mapRef"
        :center="myCenter"
        :zoom="zoom"
        map-type-id="terrain"
        :options="{ clickableIcons: false }"
        class="size"
        @center_changed="checkCenter"
      >
        <cluster
          :styles="cluster_styles"
          :gridSize="53"
          :minimumClusterSize="3"
          :maxZoom="14"
          :zoomOnClick="true"
        >
          <div v-if="cars">
            <gmap-custom-marker
              v-for="key in Object.keys(locations)"
              :key="key"
              :marker="locations[key].position"
              alignment="top"
              :zIndex="50"
            >
              <div @click="changeSelect(key, locations[key].position)">
                <div
                  v-if="selected != key"
                  class="is-gant hover-item speech-bubble"
                  style="border-radius: 5px; color: white; text-align: center;"
                >
                  <p style="padding: 5px;">
                    {{ locations[key].cheapestPrice | formatPriceFromAmount }}
                  </p>
                </div>
              </div>
            </gmap-custom-marker>
          </div>
          <div v-else>
            <gmap-custom-marker
              v-for="(hotel, index) in locations"
              :key="index"
              :marker="{
                lat: hotel.coordinates.latitude,
                lng: hotel.coordinates.longitude,
              }"
              alignment="top"
              :zIndex="50"
            >
              <div
                @click="
                  changeSelect(index, {
                    lat: hotel.coordinates.latitude,
                    lng: hotel.coordinates.longitude,
                  })
                "
              >
                <div
                  class="is-gant hover-item speech-bubble"
                  style="border-radius: 5px; color: white; text-align: center;"
                >
                  <p style="padding: 5px;">
                    ${{ hotel.cheapestPrice ? hotel.cheapestPrice : "?" }}
                  </p>
                </div>
              </div>
            </gmap-custom-marker>
          </div>
        </cluster>
        <gmap-info-window
          v-if="selected && !cars"
          :position="{
            lat: selected.coordinates.latitude,
            lng: selected.coordinates.longitude,
          }"
          :opened="infoWindOpen"
          @closeclick="reset"
        >
          <div class="columns front" style="padding-bottom: 8px;">
            <div class="column is-6" style="width: 160px;">
              <img width="150px" :src="imageDict[selected.hotelCode]" />
            </div>

            <div class="column is-6">
              <b> {{ selected.hotelName }} </b> <br />
              <br />

              <div v-if="loading">
                Checking latest rates ..
                <b-skeleton width="35%" :animated="true"></b-skeleton>
              </div>

              <div v-else>

                <div v-if="selected.cheapestPrice">Rates as low as <b>${{ selected.cheapestPrice }}</b>/night</div>
                <div v-else>No rooms found for selected dates.</div>

              </div>
              <br /><br />
              <a @click="sendSelection(selected.hotelCode)"> View this deal </a>
            </div>
          </div>
        </gmap-info-window>
        <gmap-info-window
          v-else-if="selected && cars"
          :position="selected.position"
          :opened="infoWindOpen"
          @closeclick="reset"
        >
          <div class="columns is-vcentered front" style="padding-bottom: 8px;">
            <div class="column is-4" style="width: 90px;">
              <img width="80px" :src="selected.logo" />
            </div>
            <div class="column is-8">
              <b> {{ selected.name }} </b> <br />
              <br />
              Rates as low as
              <b>{{
                selected.cheapestPrice | formatPriceFromAmount
              }}</b
              >/day<br /><br />
              <a @click="sendSelection(selected)"> View this deal </a>
            </div>
          </div>
        </gmap-info-window>
      </GmapMap>
    </div>
    <div v-if="!cars && !pathMixin_isMeeting">
      <div class="infoi" v-if="!addingData">
        <b-button v-if="newArea" type="is-primary" @click="sendSearch"
          >Search this area</b-button
        >
      </div>
      <div class="infoi" v-else>
        <b-button style="margin-right: -11px;" type="is-primary"
          >Loading results in this area</b-button
        >
        <b-button type="is-primary" loading></b-button>
      </div>
    </div>
  </div>
</template>

<script>
import GmapCustomMarker from "vue2-gmap-custom-marker";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import GoogleMapsService from '@/services/GoogleMapsService.js';
let moment = require("moment");

export default {
  name: "GMapView",
  components: {
    "gmap-custom-marker": GmapCustomMarker,
    cluster: GmapCluster,
  },
  data: function() {
    return {
      myCenter: { lat: 45.508, lng: -73.587 },
      center: {},
      loading: false,
      selectedIndex: 0,
      zoom: 11,
      infoWindOpen: false,
      maxIndex: 1,
      newArea: false,
      cluster_styles: [
        {
          // url: "https://googlemaps.github.io/js-marker-clusterer/images/m1.png",
          url: "/images/gmap_cluster_icon.png",
          // url: 'https://camo.githubusercontent.com/c1d0f94b63321e032916e45fc5d0826e417a675f800d36b9b636cd032a1d43db/68747470733a2f2f6d61726b65722e6e616e6f6b612e66722f6d61705f636c75737465722d4646303030302d3132302e737667',
          height: 53,
          width: 53,
          anchorText: [1, 0],
          textColor: "#FFFFFF",
          textSize: 10,
        },
      ],
      //   markerOptions: {
      //   url: mapMarker,
      //   size: {width: 60, height: 90, f: 'px', b: 'px',},
      //   scaledSize: {width: 30, height: 45, f: 'px', b: 'px',},
      // }
    };
  },
  props: {
    lat: Number,
    long: Number,
    locations: [],
    imageDict: Object,
    formData: Object,
    addingData: Boolean,
    cars: Boolean,
  },
  methods: {
    zoomCluster() {
      this.map.setZoom(this.map.getZoom() + 2);
    },
    getCenter() {
      this.myCenter = { lat: this.lat, lng: this.long };
      this.center = this.myCenter;
    },
    hotelSummary(hotel) {
      // console.log(hotel.hotelCode)
    },
    changeSelect(index, pos) {
      this.selectedIndex = index;
      if (this.selected.cheapestPrice == null){
        this.getRoomsAndRates();
      }
      this.infoWindOpen = true;
      // this.map.setZoom(15)
      this.map.panTo(pos);
    },
    checkCenter() {
      var center = this.map.getCenter();
      var lat = center.lat();
      var lng = center.lng();
      var dist = this.geoToDistance(this.center.lat, this.center.lng, lat, lng);
      if (dist > 10) {
        this.newArea = true;
      } else {
        this.newArea = false;
      }
    },
    sendSearch() {
      var center = this.map.getCenter();
      var lat = center.lat();
      var lng = center.lng();
      this.$emit("search", { lat: lat, lng: lng });
      this.center = { lat: lat, lng: lng };
      this.newArea = false;
    },
    geoToDistance(lat1, lon1, lat2, lon2) {
      var p = 0.017453292519943295; // Math.PI / 180
      var c = Math.cos;
      var a =
        0.5 -
        c((lat2 - lat1) * p) / 2 +
        (c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))) / 2;

      return 12742 * Math.asin(Math.sqrt(a)) * 0.621; // 2 * R; R = 6371 km
    },
    index() {
      this.maxIndex += 1;
      return this.maxIndex;
    },
    sendSelection(code) {
      this.$emit("selected", code);
    },
    reset() {
      this.infoWindOpen = false;
      this.selectedIndex = 0;
      // // console.log(this.google)
    },
    addZ() {
      for (var i = 0; i < this.locations.length; i++) {
        this.locations[i].zIndex = 52;
      }
    },
    getRoomsAndRates() {
      this.loading = true;
      // Find applicable traveler program rate codes for the traveler
      let hotelPrograms = this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ].travelerPrograms;

      let hotelChainCode = this.selected.chainCode;

      // Filter the programs
      hotelPrograms = hotelPrograms.filter((item) => {
        return (
          item.rateCode != null &&
          item.type == "Hotel" &&
          (item.providerCode == hotelChainCode ||
            item.relatedProviderCodes.includes(hotelChainCode))
        );
      });

      // Make list of applicable rate codes
      let rateCodes = [];

      for (let hotelProgram of hotelPrograms) {
        // Skip if we already have this rate code set
        if (rateCodes.includes(hotelProgram.rateCode)) continue;

        rateCodes.push(hotelProgram.rateCode);
      }

      let body = {
        stateful: true,
        sessionKey: this.session ?? null,
        normalizeResponse: true,
        travelerContactId: this.$store.getters[
          "travellersAndTrips/getCurrentTravellerProfile"
        ].id,
        travelPolicyId: this.$store.getters[
          "travellersAndTrips/getCurrentTravellerProfile"
        ].travelPolicyId,
        hotelCode: this.selected.hotelCode,
        checkInDate: moment(this.formData.checkinDate).format(
          "YYYY-MM-DD"
        ),
        checkOutDate: moment(this.formData.checkoutDate).format(
          "YYYY-MM-DD"
        ),
        tripType: this.$store.getters["travellersAndTrips/getTravellers"].tripType,
        roomCount: 1,
        guestCount: 1,
        ratePlanCodes: this.$store.state.hotelSearch.selectedHotelRates && this.$store.state.hotelSearch.selectedHotelRates.length > 0
          ? this.$store.state.hotelSearch.selectedHotelRates
          : rateCodes,
      };

      this.$app
        .huddleLabsServerCall("amadeus/hotel/live-search", body)
        .then((result) => {
          //if (result.data) {

          var payload = {
            data: result.data,
            hotelCode: this.selected.hotelCode,
            session: result.meta?.sessionKey
          };
          this.$emit("setLiveData", payload);

          // }
          this.loading = false;
        });
    },
    async initMap() {
      try {
        // Ensure Google Maps is loaded
        await GoogleMapsService.load();
        
        // Continue with existing map initialization
        this.$refs.mapRef.$mapPromise.then((map) => {
          this.map = map;
        });
      } catch (error) {
        console.error('Failed to load Google Maps:', error);
      }
    },
  },
  computed: {
    selected() {
      return this.locations[this.selectedIndex];
    },
  },
  mounted() {
    this.getCenter();
    this.initMap();
  },
};
</script>

<style scoped>
.hover-item:hover {
  background-color: gray;
}

.speech-bubble {
  width: 45px;
  position: relative;
  border-radius: 0.4em;
}

.speech-bubble:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-top-color: #ab323b;
  border-bottom: 0;
  margin-left: -5px;
  margin-bottom: -5px;
}

.speech-bubble:hover {
  background-color: gray;
}

.speech-bubble:hover:after {
  border-top-color: gray;
}

.wrap {
  position: relative;
}

.infoi {
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media screen and (max-width: 1023px) {
  .size {
    width: 300px;
    height: 500px;
    margin: auto;
  }
}

@media screen and (min-width: 1024px) {
  .size {
    width: 700px;
    height: 500px;
    margin: auto;
  }
}
</style>
